/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Password
 */
export interface Password {
    /**
     * 
     * @type {string}
     * @memberof Password
     */
    password?: string;
}

/**
 * Check if a given object implements the Password interface.
 */
export function instanceOfPassword(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PasswordFromJSON(json: any): Password {
    return PasswordFromJSONTyped(json, false);
}

export function PasswordFromJSONTyped(json: any, ignoreDiscriminator: boolean): Password {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': !exists(json, 'password') ? undefined : json['password'],
    };
}

export function PasswordToJSON(value?: Password | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}

